import React from 'react';
import { DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH } from 'components/common/DataGridDevEx/DataGrid.constants';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import DataGrid, { Column, Scrolling, GroupPanel, SearchPanel, LoadPanel, Editing } from 'devextreme-react/data-grid';
import MoreIcon from '@markinson/uicomponents-v2/SvgIcons/More';
import { IFilterGridProps } from './FilterGrid.properties';
import { withStyles } from '@material-ui/core';
import styles from './FilterGrid.styles';
const FIELD_COLUMN_WIDTH = 200;
const DRAG_COLUMN_WIDTH = 40;
const FilterGrid = (props: IFilterGridProps) => {
    const { classes, handleUpdateFilterDetails, filtersData } = props;

    const onDetailClick = React.useCallback(
        async (e: any): Promise<void> => {
            if (handleUpdateFilterDetails) {
                handleUpdateFilterDetails(e?.data?.data);
            }
        },
        [handleUpdateFilterDetails]
    );

    return (
        <DataGrid
            className={classes.FilterGrid}
            dataSource={filtersData?.ExtractFilters}
            showBorders={true}
            renderAsync={true}
            remoteOperations={true}
            allowColumnResizing={true}
            columnResizingMode={'nextColumn'}
            hoverStateEnabled={true}
            noDataText=''
            columnAutoWidth={true}
            keyExpr={'ExtractFieldId'}
        >
            <Editing
                refreshMode={'reshape'}
                mode='row'
                allowAdding={false}
                allowDeleting={false}
                allowUpdating={false}
            />
            <Column
                allowEditing={false}
                width={DRAG_COLUMN_WIDTH}
                allowResizing={false}
                fixed={true}
                alignment='center'
                allowHeaderFiltering={false}
                cellComponent={(allProps) => {
                    return <MoreIcon className={classes.lineDetailIcon} onClick={() => onDetailClick(allProps)} />;
                }}
            />
            <Column
                dataField={'FilterFieldDisplay'}
                caption={'Filter by'}
                width={FIELD_COLUMN_WIDTH}
                allowEditing={false}
                fixed={false}
            >
            </Column>
            <Column
                dataField={'Condition'}
                caption={'Condition'}
                minWidth={FIELD_COLUMN_WIDTH}
                allowEditing={false}
            >
            </Column>
            <GroupPanel visible={false} />
            <SearchPanel visible={false} />
            <Scrolling mode={'infinite'} />
            <LoadPanel shading={false} height={DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH} width={DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH} text={''} showPane={false} />
        </DataGrid>);
};

export default withStyles(styles, { index: 1 })(FilterGrid);
